import React from 'react';
import { useTrans } from '../../../hooks/useTrans';

const SOCIALS = [
    { href: 'https://www.linkedin.com/company/11422939/', modifier: 'linkedin' },
    { href: 'https://twitter.com/SchotpoortC', modifier: 'twitter' },
    { href: 'https://www.facebook.com/Schotpoort-Connect-724509431272967/', modifier: 'facebook' },
];

const CERTIFICATIONS = [
    { href: 'https://schotpoort.nl/over/kwaliteit', src: '/assets/img/layout/9001.png', alt: 'ISO 9001', width: 75 },
    { href: 'https://schotpoort.nl/over/duurzaamheid', src: '/assets/img/layout/14001.png', alt: 'ISO 14001', width: 75 },
    { href: 'https://schotpoort.nl/over/kwaliteit', src: '/assets/img/layout/27001.png', alt: 'ISO 27001', width: 75 },
    { href: 'https://schotpoort.nl/over/duurzaamheid', src: '/assets/img/layout/co2.png', alt: 'CO2 prestatieladder trede 4', width: 75 },
    { href: 'https://schotpoort.nl/over/duurzaamheid', src: '/assets/img/layout/lean.png', alt: 'Lean & Green', width: 75 },
    { href: 'https://schotpoort.nl/over/duurzaamheid', src: '/assets/img/layout/pso.png', alt: 'PSO prestatieladder 30+', width: 107 },
];

export default function PublicFooter() {
    const translate = useTrans();

    return (
        <footer className="portal__footer portal__footer--schotpoort">
            <div className="wrapper wrapper--large">
                <div className="row">
                    <div className="scol12 col9">
                        <a href="https://schotpoort.nl/" target="_blank" rel="noreferrer">
                            <span className="schotpoort-logo schotpoort-logo--large footer-logo" />
                        </a>

                        <div className="row">
                            <div className="scol12 tcol6 col4">
                                <h4 className="footer-title">{translate('Hoofdvestiging')}</h4>
                                <p className="footer-location">Coldenhovenseweg 74<br />6961 EG EERBEEK</p>
                            </div>
                            <div className="scol12 tcol6 col4">
                                <a className="footer-link footer-link--phone" href="tel:0313 - 670 250">0313 - 670 250</a>
                                <a className="footer-link footer-link--email" href="mailto:cs@schotpoort.nl">cs@schotpoort.nl</a>
                            </div>
                            <div className="scol12 tcol6 col4">
                                <div className="socials-footer">
                                    {SOCIALS.map(({ href, modifier }) => (
                                        <a key={modifier} href={href} target="_blank" rel="noreferrer" className={`social social--${modifier}`} />
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            {CERTIFICATIONS.map(({ href, src, alt, width }) => (
                                <div key={alt} className="scol4 tcol4 col2">
                                    <a href={href}>
                                        <img width={width} height={75} className="certification-image" src={src} alt={alt} />
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="scol12 col3">
                        <img src="/assets/img/layout/map.svg" alt="" title="" className="footer-image footer-image--map" />
                    </div>
                </div>
            </div>
        </footer>
    );
}
